import { alpha, buttonClasses } from '@mui/material';
import { colors } from '../constants';
import { SHADOW_LEVEL2 } from '../shadows';
const styleOverrides = {
  root: ({
    ownerState,
    theme
  }) => ({
    lineHeight: 1.5,
    borderRadius: 25,
    ...(ownerState.variant === 'outlined' && ownerState.color === 'default' && {
      color: colors.oriGrey[900],
      border: `1px solid ${colors.oriGrey[900]}`,
      '&:hover,&:focus': {
        color: colors.oriGrey[900],
        border: `1px solid ${colors.oriGrey[900]}`
      },
      [`&.${buttonClasses.disabled}`]: {
        background: colors.action.disabledBackground,
        borderColor: 'transparent'
      }
    }),
    ...((ownerState.color === 'bannerButton' || ownerState.color === 'frontPage') && {
      backdropFilter: 'blur(15px)',
      '&:hover': {
        color: colors.text.primary
      },
      [`&.${buttonClasses.focusVisible}`]: {
        background: colors.bannerButton.dark,
        color: colors.text.primary
      },
      [`&.${buttonClasses.disabled}`]: {
        background: alpha(colors.commonColors.black, 0.4),
        color: colors.text.primary
      }
    }),
    ...(ownerState.variant === 'contained' && ownerState.color === 'superApp' && {
      background: `linear-gradient(90deg, ${colors.superApp.light} 0%, ${colors.superApp.main} 100%)`,
      '&:hover,&:focus': {
        boxShadow: SHADOW_LEVEL2
      },
      [`&.${buttonClasses.disabled}`]: {
        background: colors.action.disabledBackground
      }
    }),
    ...(ownerState.variant === 'outlined' && ownerState.color === 'superApp' && {
      borderWidth: '3px',
      borderColor: colors.superApp.main,
      '&:hover,&:focus': {
        borderWidth: '3px',
        boxShadow: SHADOW_LEVEL2
      },
      [`&.${buttonClasses.disabled}`]: {
        borderWidth: '3px'
      }
    }),
    ...(ownerState.variant === 'contained' && ownerState.color === 'secondary' && {
      background: alpha(colors.primary.light, 0.3),
      color: colors.primary.dark
    })
  }),
  sizeSmall: ({
    ownerState
  }) => ({
    padding: '10px 23px',
    ...(ownerState.variant === 'outlined' && ownerState.color === 'superApp' && {
      padding: '7px 20px'
    })
  }),
  iconSizeSmall: {
    fontSize: 24,
    marginTop: -4,
    marginBottom: -4
  },
  sizeMedium: ({
    ownerState
  }) => ({
    padding: '12px 23px',
    ...(ownerState.variant === 'outlined' && ownerState.color === 'superApp' && {
      padding: '10px 20px',
      lineHeight: 1.443
    })
  }),
  iconSizeMedium: {
    fontSize: 26,
    marginTop: -4,
    marginBottom: -4
  },
  sizeLarge: ({
    ownerState
  }) => ({
    padding: '14px 23px',
    lineHeight: 1.25,
    ...(ownerState.variant === 'outlined' && ownerState.color === 'superApp' && {
      padding: '11px 20px'
    })
  }),
  iconSizeLarge: {
    fontSize: 28,
    marginTop: -5,
    marginBottom: -5
  },
  startIcon: {
    // eslint-disable-next-line @typescript-eslint/naming-convention -- css selector
    '>*:nth-of-type(1)': {
      fontSize: 'inherit'
    }
  },
  endIcon: {
    // eslint-disable-next-line @typescript-eslint/naming-convention -- css selector
    '>*:nth-of-type(1)': {
      fontSize: 'inherit'
    }
  },
  text: {
    padding: '10px 23px'
  },
  textPrimary: {
    '&:hover,&:focus': {
      color: colors.primary.main
    }
  },
  textSecondary: {
    '&:hover,&:focus': {
      color: colors.secondary.main
    }
  },
  contained: {
    borderRadius: 25
  },
  containedPrimary: {
    '&:hover,&:focus': {
      color: colors.primary.contrastText
    }
  },
  containedSecondary: {
    '&:hover,&:focus': {
      color: colors.primary.dark,
      background: alpha(colors.primary.main, 0.3)
    }
  },
  outlined: {
    borderRadius: 25,
    padding: '10px 23px',
    lineHeight: 1.386
  },
  outlinedPrimary: {
    '&:hover,&:focus': {
      color: colors.primary.main
    }
  },
  outlinedSecondary: {
    '&:hover,&:focus': {
      color: colors.secondary.main
    }
  }
};
const defaultProps = {
  disableElevation: true,
  color: 'default'
};
export default {
  defaultProps,
  styleOverrides
};
//# sourceMappingURL=MuiButton.js.map